import React from "react";
import Header from "./components/Header";

const AdminLayout = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default AdminLayout;
